import "./ReportLogin.css";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProcessLoginUserData, processLogout } from "../../api/cventapi";
import { UserContext } from "../../common/UserContext";
import { UserData } from "../../models/User";
import { UserAPIdata } from "../../models/userAPIdata";
import { ReportLogin } from "../../models/content-types/reportLogin";
import { PageLayout } from "../../models";

type LoginProps = {
  loginPageData: ReportLogin;
  headerPageData: PageLayout;
  eventTypes: string;
};
const emailRegex = /^[a-zA-Z0-9._%+-]+@one10marketing\.com$/;

enum AccessCodeEnum {
  CODE_1 = "CVENTREPORT",
}

const ReportLoginPage: React.FC<LoginProps> = ({ loginPageData, headerPageData, eventTypes }) => {
  const [userName, setUserName] = useState("");
  const [accessCode, setAccessCode] = useState("");
  const [showValidationError, setShowValidationError] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const { setUserData } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    processLogout();
    setShowValidationError(false);
    setErrors([]);
    return () => {
      setShowValidationError(false);
      setErrors([]);
    };
  }, []);

  const validateLogin = () => {
    setShowValidationError(false);
    setErrors([]);
    let valErrors = [];
    if (loginPageData && loginPageData.elements) {
      // Check if the userName and accessCode are empty
      if (!userName) {
        valErrors.push(loginPageData.elements.first_textbox_required_error_message.value);
      }
      if (!accessCode) {
        valErrors.push(loginPageData.elements.second_textbox_required_error_message.value);
      }

      // Check if the userName is a valid email address and if the accessCode is valid
      if (userName && !emailRegex.test(userName)) {
        valErrors.push(loginPageData.elements.first_textbox_invalid_data_message.value);
      }
      if (accessCode && accessCode !== AccessCodeEnum.CODE_1) {
        valErrors.push(loginPageData.elements.second_textbox_invalid_data_message.value);
      }
    }
    return valErrors;
  };

  const login = async () => {
    setErrors([]);
    let valErrors = validateLogin();
    if (valErrors && valErrors.length > 0) {
      setShowValidationError(true);
      setErrors(valErrors);
      return;
    }
    const dataForApi: UserAPIdata = {
      userName: userName,
      password: accessCode,
      firstName: "",
      lastName: "",
      eventType: eventTypes,
      IsReporting: true
    };
    processLoginData(dataForApi);
  };

  const processLoginData = async (dataForApi: UserAPIdata) => {
    try {
      const loginResponse: { succeeded: boolean; data?: any } = await ProcessLoginUserData(dataForApi);
      if (loginResponse?.succeeded) {
        let apiResponse = loginResponse.data;
        localStorage.setItem("userdetail", JSON.stringify(apiResponse));

        if (!apiResponse?.authorizationPolicy) {
          apiResponse.authorizationPolicy = ["cventrt"];
        }

        let userDataFromApi: UserData = {
          isDealer: apiResponse?.dealerInfo?.isDealer,
          executiveManager: apiResponse?.dealerInfo?.executiveManager,
          generalManager: apiResponse?.dealerInfo?.generalManager,
          authorizationPolicy: apiResponse?.authorizationPolicy,
          accessCode: dataForApi?.password,
        };

        // Persist accessCode so it survives page refresh
        localStorage.setItem("accessCode", dataForApi?.password ?? "");

        setUserData(userDataFromApi);
        const userDetail = localStorage.getItem("userdetail");
        if (userDetail) {
          navigate("/nbc/dashboard");
        }
        
      } else {
        setShowValidationError(true);
        setErrors([loginPageData.elements.second_textbox_invalid_data_message.value]);
      }
    } catch (error) {
      setShowValidationError(true);
      setErrors(["Unexpected error. Please try again"]);
    }
  };

  return (
    <>
      {loginPageData && headerPageData && (
        <div id="main-wrapper">
          <section className="header">
            <div className="header-text">
              <div className="row">
                <div className="pt-5">
                  <span className="header-text font-bold font-20">{loginPageData.elements.content_header_text.value}</span>
                </div>
              </div>
            </div>
          </section>
          <section className="login pt-3 pb-2">
            <div className="container">
              <form>
                <h3 className="login-header">{loginPageData.elements.header_text.value}</h3>
                <div className="row m-t-40 input-row">
                  <div className="col-md-6 col-lg-6">
                    <div className="mb-3">
                      <input className="form-control logininput" type="text" placeholder={loginPageData.elements.first_textbox_placeholder_text.value} onChange={(e) => setUserName(e.target.value)}></input>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="mb-3">
                      <input type="text" className="form-control logininput" placeholder={loginPageData.elements.second_textbox_placeholder_text.value} onChange={(e) => setAccessCode(e.target.value)}></input>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="mb-3">
                    <button type="button" className="btn btn-primary mt-3 mb-3 loginbutton" onClick={login}>
                      {loginPageData.elements.button_text.value}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </section>
          {showValidationError && errors.length > 0 && (
            <ul className="errorsummary pt-1">
              {errors.map((e, i) => {
                return (
                  <>
                    {" "}
                    <li>{e}</li>
                  </>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </>
  );
};

export default ReportLoginPage;
